import type { ProxiedMCPRequest } from '../types/mcp'
import type { AuthenticatedFetch } from '../types/network'
import { isRecord } from '../utils/json'

function normalizeProxyResponse(payload: unknown): unknown {
  if (
    isRecord(payload) &&
    'result' in payload &&
    (payload.jsonrpc === '2.0' || 'id' in payload)
  ) {
    return payload.result
  }

  return payload
}

export async function proxyMCPRequest<T>(
  authenticatedFetch: AuthenticatedFetch,
  proxyEndpoint: string,
  request: ProxiedMCPRequest,
): Promise<T> {
  if (!request.serverId && !request.serverHash) {
    throw new Error('MCP proxy request requires serverId or serverHash')
  }

  const response = await authenticatedFetch(proxyEndpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  })

  const text = await response.text()
  const payload = text ? (JSON.parse(text) as unknown) : {}

  if (!response.ok) {
    const message =
      isRecord(payload) && typeof payload.message === 'string'
        ? payload.message
        : response.statusText
    throw new Error(`MCP proxy failed: ${message}`)
  }

  return normalizeProxyResponse(payload) as T
}
